export const StatutMedicamentLabels = {
    TRAITE:       "Traité",
    EN_LIVRAISON: "En livraison",
    EN_COMMANDE:  "En commande",
    EN_RUPTURE:   "Rupture de stock",
    LIVRE:        "Livré",
    NON_LIVRE:    "Non livré",
};

export const StatutMedicamentColors = {
    TRAITE:       { bg: "#dcfce7", color: "#166534" },
    EN_LIVRAISON: { bg: "#ede9fe", color: "#6d28d9" },
    EN_COMMANDE:  { bg: "#fef3c7", color: "#92400e" },
    EN_RUPTURE:   { bg: "#f1f5f9", color: "#64748b" },
    LIVRE:        { bg: "#dbeafe", color: "#1d4ed8" },
    NON_LIVRE:    { bg: "#fee2e2", color: "#991b1b" },
};
